import BaseComponent from "../BaseComponent";
import ToggleInput from "components/Properties/InputComponents/ToggleInput";
import DropDownInput from "components/Properties/InputComponents/DropDownInput";

const BehaviorComponent = ({isObjectScripting, selectedObject, checkboxOnChange, dropdownOnChange, dropdownOpened, setDropdownOpened}) => {
  const {type} = selectedObject;
  const isKinematic = selectedObject.userData.isKinematic || false;
  const canCollide = selectedObject.userData.canCollide || false;
  const isStatic = selectedObject.userData.static || false;
  const objectType = selectedObject.userData.type;

  const bodyType = selectedObject.userData.bodyType || "Default";
  const canScript = selectedObject.userData.canScript || false;

  return (
    <BaseComponent title="Behavior" foldable={true}>
      {!isObjectScripting && <ToggleInput name="Script" checked={canScript} checkboxOnChange={checkboxOnChange} />}
      {type !== "Sprite" && (
        <>
          {!isObjectScripting && (
            <DropDownInput
              name="BodyType"
              array={["Default", "Box", "Sphere", "Hull", "Convex", "Concave"]}
              dropdownOnChange={dropdownOnChange}
              value={bodyType.charAt(0).toUpperCase() + bodyType.slice(1)}
              selectedObject={selectedObject}
              dropdownOpened={dropdownOpened}
              setDropdownOpened={setDropdownOpened}
            />
          )}
          {type === "Mesh" && objectType === "mesh" && (
            <>
              <ToggleInput name="CanCollide" checked={canCollide} checkboxOnChange={checkboxOnChange} />
              {isObjectScripting && canCollide && (
                <ToggleInput name="Static" checked={isStatic} checkboxOnChange={checkboxOnChange} depth={1} />
              )}
              {!isObjectScripting && <ToggleInput name="Anchored" checked={isKinematic} checkboxOnChange={checkboxOnChange} />}
              <ToggleInput name="Shadow" checked={selectedObject.castShadow} checkboxOnChange={checkboxOnChange} />
            </>
          )}
          {type === "Mesh" && objectType === "video" && (
            <>
              <ToggleInput name="CanCollide" checked={canCollide} checkboxOnChange={checkboxOnChange} />
              {isObjectScripting && canCollide && (
                <ToggleInput name="Static" checked={isStatic} checkboxOnChange={checkboxOnChange} depth={1} />
              )}
            </>
          )}
          {type === "Group" && (
            <>
              <ToggleInput name="CanCollide" checked={canCollide} checkboxOnChange={checkboxOnChange} />
              {isObjectScripting && canCollide && (
                <ToggleInput name="Static" checked={isStatic} checkboxOnChange={checkboxOnChange} depth={1} />
              )}
              {!isObjectScripting && <ToggleInput name="Anchored" checked={isKinematic} checkboxOnChange={checkboxOnChange} />}
              <ToggleInput name="Shadow" checked={selectedObject.castShadow} checkboxOnChange={checkboxOnChange} />
            </>
          )}
        </>
      )}
    </BaseComponent>
  );
};

export default BehaviorComponent;
